import { useUserStore } from '@/stores/user'
import { useSyncStore } from '@/stores/sync'
import { useContainerTypeStore } from '@/stores/container_types'
import { useIncidentTypeStore } from '@/stores/incident_types'
import { useContainerStore } from '@/stores/containers'
import { useRoomStore } from '@/stores/rooms'
import { DataType } from './data'

const load = async (dataType: DataType) => {
  const userStore = useUserStore()
  const apiUrl =
    import.meta.env.VITE_USE_MOCKS !== 'true'
      ? `${import.meta.env.VITE_API_URL}/${dataType}`
      : new URL(`/src/mocks/get/${dataType}.json`, import.meta.url).href

  const options = {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
      Authorization: 'Bearer ' + userStore.authenticatedUser?.token,
    },
  }

  const response = await fetch(apiUrl, options)
  if (response.status === 401) {
    userStore.logout()
    throw new Error(
      `[HTTP ${
        response.status
      }] Failed to fetch ${dataType} data, auth token is not valid: ${JSON.stringify(response)}`,
    )
  } else if (!response.ok) {
    throw new Error(
      `[HTTP ${response.status}] Failed to fetch ${dataType} data: ${JSON.stringify(response)}`,
    )
  }

  return await response.json()
}

export const loadDataFromApi = async () => {
  const userStore = useUserStore()
  const syncStore = useSyncStore()
  if (!navigator.onLine || !userStore.isAuthenticated || syncStore.hasDataToSync) return false

  const dataStores = {
    [DataType.ContainerType]: useContainerTypeStore(),
    [DataType.IncidentType]: useIncidentTypeStore(),
    [DataType.Container]: useContainerStore(),
    [DataType.Room]: useRoomStore(),
  }

  for (const dataType of Object.values(DataType)) {
    const newData = await load(dataType)
    const store = dataStores[dataType]
    store.setData(newData)
  }

  return true
}
